import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Paragraph, Subtitle } from "../pages/home/sections/About";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";

import { CarWhatsappBtn } from "./WhatsappBTN";

const CodeParagraph = styled(Paragraph)`
  color: var(--grey);

  font-weight: 400;
  font-size: 0.9rem;
  span {
    font-weight: 700;
  }
`;

const CodeTitle = styled(Subtitle)`
  font-weight: 300;
  font-family: var(--raleway);
  font-size: 2rem;
  text-transform: uppercase;
  text-align: center;
  span {
    font-weight: 700;
  }
`;

const CardText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const InfoContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  transform: ${(props) =>
    props.active ? "translateY(0%)" : "translateY(200%)"};
  transition: 0.6s all ease-in;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.914);
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  @media (max-width: 400px) {
    padding: 0 10px;
    text-align: center;
    justify-content: center;
  }
`;
const CodeItem = styled(CodeParagraph)`
  font-size: 1rem;
  font-weight: 500;
  width: 100%;
  text-align: center;
`;

const VehicleCardUI = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 0px;
  width: min(320px, 90%);
  height: 370px;
  gap: 40px;
  border-radius: 20px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  overflow: hidden;
  position: relative;
`;

const VehicleImg = styled.img`
  height: 160px;
  @media (max-width: 400px) {
    height: 140px;
  }
`;

const ShowMoreBtn = styled.button`
  background: transparent;
  border: none;
  color: var(--red);
  font-size: 0.9rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  position: absolute;
  bottom: 20px;
  cursor: pointer;
  svg {
    font-size: 0.7rem;
    margin-top: -1.5px;
  }
`;

const VehicleCard = ({ item }) => {
  const [active, setActive] = useState(false);

  const {
    marca,
    modelo,
    puertas,
    asientos,
    motor,
    direccion,
    linea1,
    linea2,
    linea3,
    transmision,
    codigo,
    imagen,
  } = item;

  const mensaje =
    `Hola, estoy interesado/a en el alquiler del auto ${marca} ${modelo} de código ${codigo}, quisiera saber si tienen disponibilidad para la fecha...`
      .split(" ")
      .join("%20");

  return (
    <>
      <VehicleCardUI data-aos="fade-right">
        <VehicleImg src={imagen} />
        <CardText>
          <TitleContainer>
            <CodeTitle>
              <span>{marca}</span> {modelo}
            </CodeTitle>
            <CodeParagraph>
              Código de vehículo: <span>{codigo}</span>
            </CodeParagraph>
            <ShowMoreBtn onClick={() => setActive(true)}>
              {" "}
              <FontAwesomeIcon icon={faArrowUp} />
              Ver Detalles{" "}
            </ShowMoreBtn>
          </TitleContainer>
          <InfoContainer active={active}>
            <CodeItem>
              {puertas} Puertas - {asientos} Asientos{" "}
            </CodeItem>
            <CodeItem>Motor: {motor}</CodeItem>
            <CodeItem>Dirección: {direccion}</CodeItem>
            <CodeItem>Transmisión: {transmision}</CodeItem>
            <CodeItem>{linea1}</CodeItem>
            <CodeItem>{linea2}</CodeItem>
            <CodeItem>{linea3}</CodeItem>
            <CarWhatsappBtn
              msg={`https://api.whatsapp.com/send?phone=5491130710101&text=${mensaje}`}
            />
            <ShowMoreBtn onClick={() => setActive(false)}>
              {" "}
              <FontAwesomeIcon icon={faArrowDown} />
              Ocultar detalles{" "}
            </ShowMoreBtn>
          </InfoContainer>
        </CardText>
      </VehicleCardUI>
    </>
  );
};

export default VehicleCard;
